import { Button, Col, message, Modal, Typography } from "antd";
import { deleteArtwork, deleteArtworkVersion } from "../../../api/artwork";
import "./style.scss";


export const DeletePopupModal = (props: any) => {
    const { id, open, setOpen, title, setDeleteBtnLoading, deleteBtnLoading, type, userId, render, artId } = props;

    const { Text } = Typography;

    const onHandleDelete = async (id: number) => {
        try {
            setDeleteBtnLoading(true);
            if (type === 'ArtWorkVersion') {
                await deleteArtworkVersion({ id: id, userId: userId });
            } else if (type === 'ArtWorkList') {
                await deleteArtwork({ id: id, userId: userId });
            } else {
                throw new Error("Invalid delete type");
            }

        } catch (error: any) {
            message.error(error.message || "Something went wrong", 5);
        } finally {
            setDeleteBtnLoading(false);
            setOpen(false);
            const param = artId ? { artId: artId } : { filter: [] };
            render({
                ...param,
                userId: userId
            });
        }
    };

    return (
        <Modal
            title={`Confirm Delete`}
            open={open}
            width={600}
            onCancel={() => setOpen(false)}
            maskClosable={false}
            footer={[
                <div key={id} style={{ marginTop: 20 }}>
                    <Button
                        key="back"
                        danger
                        onClick={() => setOpen(false)}
                        style={{ letterSpacing: "0.5px", fontWeight: "bold", marginRight: 15 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        key="submit"
                        type='primary'
                        onClick={() => onHandleDelete(id)}
                        loading={deleteBtnLoading}
                        style={{ letterSpacing: "0.5px", fontWeight: "bold", background: 'rgb(99, 106, 232)' }}
                    >
                        Delete
                    </Button>
                </div>
            ]}
        >
            <div className='confirmation-delete-content'>
                <Col>
                    <Text style={{ fontSize: 18 }}>Are you sure you want to delete the Artwork - <span style={{ fontWeight: 600 }}>{title}</span>?</Text>
                </Col>
                <Col>
                    {type !== 'ArtWorkVersion' && <Text style={{ fontSize: 16 }}>Deleting this record will delete all associated data</Text>}
                </Col>
            </div>
        </Modal>
    );
};
